module.exports = __webpack_public_path__ + "static/media/isdoctorplan-bariatric1@2x.e5728c27.png";